"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/** This is a placeholder, not real render in dom */
var TreeNode = function TreeNode() {
  return null;
};

var _default = TreeNode;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/lib/TreeNode.js
// module id = 171
// module chunks = 0